exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ba-hr-column[data-v-2cf3b05c]{min-height:26px}.ba6-affiliation-status[data-v-2cf3b05c]{font-size:12px;font-weight:600}.ba6-switch-span[data-v-2cf3b05c]{font-size:12px;font-weight:700}.ba6-sponsored-button[data-v-2cf3b05c]{background:transparent;border:none;outline:none;cursor:pointer}.ba6-sponsored-button .ba6-sponsored-text[data-v-2cf3b05c]{color:rgba(77,93,113,.8);font-size:12px;font-weight:500}.ba6-label-message-to-sponsor[data-v-2cf3b05c]{font-size:14px}.ba6-switch-element[data-v-2cf3b05c]{width:-webkit-max-content;width:-moz-max-content;width:max-content}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2cf3b05c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/office-v6/account-settings/routes/Affiliation.vue
// module id = euoB
// module chunks = 0